export default __webpack_public_path__ + "static/media/quality.f2f529f5.png";